import React from 'react';
import { Icon, Table } from 'semantic-ui-react';
import { isValidDataModel } from '../../datamodels/helper';
import { validationStatusIconProps } from '../../data/helper';

const DataModelValidationStatusCell = ({ status }) => {
  const valid = isValidDataModel(status);
  return (
    <Table.Cell>
      <Icon
        color={validationStatusIconProps(valid).colour}
        name={validationStatusIconProps(valid).name}
      />
      {status}
    </Table.Cell>
  );
};

export default DataModelValidationStatusCell;
